<template>
  <div id="CORequestList">
    <div class="labelTitle lable">ケア オーケストレーター 申請一覧</div>
    <!--検索条件 -->
    <div class="condition-area">
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input type="text" id="receiptNumber" v-model="searchConditions.receiptNumber"/></td>
            <th>種別</th>
            <td><select id="種別" v-model="searchConditions.kind"><option></option><option value="1">施設登録</option><option value="2">施設変更</option><option value="3">ユーザー追加</option><option value="4">ユーザ変更</option><option value="5">ユーザ削除</option></select></td>
            <th>申込み状況</th>
            <td><select id="申込み状況" v-model="searchConditions.status"><option></option><option value="1">申込中</option><option value="2">登録済</option><option value="3">キャンセル</option></select></td>
            <template v-if="isDealer()">
              <th>医療機関名</th>
              <td><input type="text" id="医療機関名" v-model="searchConditions.medicalInstitutionName"/></td>
            </template>
            <template v-else>
              <td colspan="2"></td>
            </template>
          </tr>
          <tr>
            <th>申込日</th>
            <td colspan="3"><input type="date" id="applicationDateStart" v-model="searchConditions.applicationDateStart"/> ～ <input type="date" id="applicationDateEnd" v-model="searchConditions.applicationDateEnd"/></td>
            <th>完了日</th>
            <td colspan="3"><input type="date" id="shippingDateStart" v-model="searchConditions.completionDateStart"/> ～ <input type="date" id="shippingDateEnd" v-model="searchConditions.completionDateEnd"/></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button class="is-primary" @click="doSearch">検索</b-button>
        </div>
      </div>
    </div>
    <!-- 検索結果 -->
    <div class="result-area" v-if="data.length > 0">
      <div>
        <b-table
          :data="data"
          :paginated="true"
          per-page="10"
          pagination-position="both"
          default-sort="user.first_name"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column field="受付番号" label="受付番号" width="70" centered>
              <a @click="showDetail(props.row)">{{props.row.receiptNumber}} <b-icon icon="vector-arrange-above"/></a>
            </b-table-column>
            <b-table-column field="種別" label="種別" width="100" centered>{{props.row.kind | coOrderTypeFilter()}}</b-table-column>
            <b-table-column v-if="isDealer()" field="医療機関名" label="医療機関名" width="200" class="breakAll">{{props.row.medicalInstitutionName}}</b-table-column>
            <b-table-column field="申込日" label="申込日" width="100" centered>{{props.row.applicationDate}}</b-table-column>
            <b-table-column field="完了日" label="完了日" width="100" centered>{{props.row.completionDate}}</b-table-column>
            <b-table-column field="申込み状況" label="申込み状況" width="100" centered>
              <span :class="getTagClass4CoExternalUserStatus(props.row.applicationStatus)" style="width:100px;">{{props.row.applicationStatus | coExternalStatusFilter()}}</span>
            </b-table-column>
            <b-table-column field="取下げ" label="取下げ" width="35" centered>
              <a v-if="props.row.applicationStatus === 1 || props.row.applicationStatus === 5" @click="cancel(props.row.receiptNumber)"><b-icon icon="file-replace-outline"/></a>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
    <floatingDiv v-if="isShowDetail" @close="closeDetail" title="" width="640px" height="480px" top="100px" right="100px">
      <coRegistRequestDetail :institutionApplication="showDetailData.institutionApplication" :mergedUserInfoList="showDetailData.userInfoList" />
    </floatingDiv>
  </div>
</template>
<script>
import {role} from "@/components/mock/base/const.js";
import floatingDiv from "@/components/mock/common/FloatingDiv";
import CORegistRequestDetail from "@/components/mock/common/CORegistRequestDetail";
export default {
  name: "CORequestList",
  methods: {
    doSearch: function() {
      var excuteApi = this.getCoSettingRequestListPOST;
      var successCallBack = this.getCoSettingRequestListPOSTSuccess;
      var errorCallBack = this.getCoSettingRequestListPOSTError;
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack);
    },
    getCoSettingRequestListPOST: function(client) {
      var obj = JSON.parse(JSON.stringify(this.searchConditions));
      obj.belongsId = this.belongsId
      return client.apis.externalCOSetting.getCoSettingRequestListPOST({
        body:obj
      });
    },
    getCoSettingRequestListPOSTSuccess: function(result) {
      // 検索結果取得
      this.data = result.obj
    },
    getCoSettingRequestListPOSTError: function(result) {
      // エラーメッセージ表示
      this.showErrorMessage(result);
    },
    showDetail: function(item) {
      this.showDetailData = item
      this.isShowDetail = true;
    },
    closeDetail: function(){
      this.isShowDetail = false;
      this.showDetailData = {}
    },
    cancel: function(receiptNumber) {
      this.cancelReceiptNumber = receiptNumber
      var _this = this;
      this.$dialog.confirm({
        title: "　",
        message: "申請を取下げますか？",
        cancelText: "キャンセル",
        onConfirm: async () => {
          // Web Api Call
          _this.apiCall(
            function(client){
              return client.apis.externalCOSetting.setCoSettingRequestCancelPOST({
                body:{
                  receiptNumber: _this.cancelReceiptNumber
                }
              });
            },
            async function(result){
              _this.showSuccess(result, function(){
                var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
                if(userInfo.coType = 2 && !_this.isDealer()){
                  // 自身の所属先IDに紐づく施設登録を取下げた場合
                  userInfo.coType = 1
                  userInfo.CoApplicationReceiptNumber = 0
                  sessionStorage.setItem('userInfo', JSON.stringify(userInfo));
                  _this.$emit('backMenu');
                  return
                }else{
                  _this.cancelReceiptNumber = ""
                  _this.doSearch()
                }
              });
            },
            function(result){
              // エラーメッセージ表示
              _this.showErrorMessage(result);
              _this.cancelReceiptNumber = ""
            }
          );
        }
      });
    },
    setCoSettingRequestCancelPOSTSuccess: function(result) {
      this.showSuccess(result);
    },
    isDealer: function(){
      return this.roleId == this.role.role_dealer;
    }
  },
  data() {
    var userInfo = JSON.parse(sessionStorage.getItem("userInfo"));
    return {
      searchConditions:{
      receiptNumber : "",
      kind : "",
      status : "",
      medicalInstitutionName : "",
      applicationDateStart : "",
      applicationDateEnd : "",
      completionDateStart : "",
      completionDateEnd : ""
    },
    role: role,
    roleId: userInfo.roleId,
    belongsId:userInfo.belongsId,
    data: [],
    isPaginated: true,
    isShowDetail: false,
    showDetailData:{},
    cancelReceiptNumber:""
    };
  },
  filters: {},
  components: {
    floatingDiv: floatingDiv,
    coRegistRequestDetail:CORegistRequestDetail,
  },
  mounted: function() {}
};
</script>
<style lang="scss" scoped>
input {
  width: 200px;
}
a {
  text-decoration: underline;
}
.cancelButton {
  width: 100px;
  height: 24px;
}
</style>


// WEBPACK FOOTER //
// src/components/mock/guest/careorchestrator/setting/CORequestList.vue